import React, {useState, useEffect, useRef} from "react";
// import MytypedComponent from "../typing-effect/typing.js"
// import TOGGLE from "../toggle-button/toggle";
import HomePage from "../Main-page/HomePage";
// import logo from "./logoo.png"
import hamLogo from "./ham.svg";
import logoClose from "./ham-c.svg";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import { Link, animateScroll as scroll } from "react-scroll";
import styled from "styled-components";
import "./styles.scss";

const Wrapper = styled.div`
  display: block;
  width:80%;
  margin-top: 20px;
  @media (max-width: 470px) {
    margin: 0;
    display: ${props => (props.toggle ? "none" : "static")};
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: ${props => (props.toggle ? "-1000px" : "0px")};
    transition: top 1s;
    .nav-content {
      height: 35%;
      background-color: rgba(50, 13, 136);
    }
  }
`;

const NAVBAR = ({}) => {
  const [toggle, setToggle] = useState(true);
  const [color, setColor] = useState("#121930");

  const navigation = useRef();

  const listenScrollEvent = e => {
    if (window.scrollY > 800) {
      setColor("#121930");
    } else {
      setColor("#121930");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    console.log(navigation);
  }, []);

  const handleOutsideCick = (event, ref) => {
    if (!ref.current.contains(event.target)) {
      setToggle(true);
    } else {
      setToggle(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", e =>
      handleOutsideCick(e, navigation)
    );

    return () => {
      document.removeEventListener("mousedown", e =>
        handleOutsideCick(e, navigation)
      );
    };
  }, []);

  return (
    <Router>
      <nav className="nav_bar" style={{backgroundColor: color}}>
        <a id="mlh-trust-badge"
        href="https://mlh.io/na?utm_source=na-hackathon&utm_medium=TrustBadge&utm_campaign=2023-season&utm_content=blue"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "block", maxWidth: "100px", minWidth: "60px", position: "fixed", right: "50px", top: "0", width: "10%", zIndex: "10000" }}>
        <img src="https://s3.amazonaws.com/logged-assets/trust-badge/2023/mlh-trust-badge-2023-blue.svg"
                alt="Major League Hacking 2023 Hackathon Season"
                style={{ width: "100%" }} />
        </a>

        <Wrapper toggle={toggle}>
          <div className="nav-content" ref={navigation}>
          <ul>
              <li>          
              </li>
              <li>
                <Link to={`home`}>
                  <span className="links">Home </span>{" "}
                </Link>
              </li>
              <li>
                <Link 
                  activeClass="active"
                  to="about"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}>
                  <span className="links">About </span>{" "}
                </Link>
              </li>
              <li>
                <Link     
                  activeClass="active"
                  to="faq"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}>
                  <span className="links">FAQ </span>{" "}
                </Link>
              </li>
              {/* <li>
                <Link 
                  activeClass="active"
                  to="sponsor"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}>
                  <span className="links">Sponsors </span>{" "}
                </Link>
              </li> */}
              <img
                className="s-close"
                onClick={() => setToggle(true)}
                src={logoClose}
              />              
            </ul>
          </div>
          <div className="ease" />
        </Wrapper>
        <img
          className="s-open"
          onClick={() => setToggle(false)}
          src={hamLogo}
        />        
      </nav>

      <Switch>
        <Route path="/">
          <HomePage />
        </Route>
      </Switch>
    </Router>
  );
};
function Projects() {
  return <h2>Projects here</h2>;
}

function Contact() {
  return <h2>contact info</h2>;
}

function Links() {
  return <h2>Home</h2>;
}
export default NAVBAR;